<template>
  <v-dialog
      v-model="showAppCreator"
      persistent
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Create Application</span>
      </v-card-title>
      <v-form ref="form" lazy-validation v-model="valid">
        <v-card-text class="py-0">
          <v-container>
            <span>Display name</span>
            <br/>
            <small>This is the display name associated with your app ID</small>
            <v-text-field outlined dense :rules=formRules.required v-model="application.name"></v-text-field>
            <span>Description</span>
            <br/>
            <small>This is the description of your app's features.</small>
            <v-textarea outlined dense :rules=formRules.required v-model="application.description"></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
              depressed
              class="text-none"
              @click="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
              color="primary"
              depressed
              class="text-none"
              @click="submit"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {sync} from "vuex-pathify";
import FormMixin from "@/mixins/form.mixin"
import {mapActions} from "vuex";

export default {
  name: "ApplicationCreator",
  mixins: [FormMixin],
  data() {
    return {
      application: {
        name: '',
        description: ''
      }
    }
  },
  computed: {
    showAppCreator: sync('dialogs/showAppCreator')
  },
  methods: {
    ...mapActions('application', ['create']),
    submit () {
      if (this.$refs.form.validate()) {
        this.create(this.application)
        this.reset()
      }
    },
    cancel() {
      this.showAppCreator = false;
      this.reset();
    },
    reset() {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    }
  }
}
</script>

<style scoped>

</style>
